export default __webpack_public_path__ + "static/media/feature-bg.dfda8aeb.png";